import React,{useRef} from 'react';
import {Box, Grid, Button} from '@material-ui/core';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import TestViewDetailsHelp from '../components/TestViewDetailsHelp';
import LinearProgress from '@mui/material/LinearProgress';
import DialogFeedback from '../components/DialogFeedback';
import { MathJaxContext } from "better-react-mathjax";
import '../styles/bizofficer.css';
import {API_URL} from '../utils/EnvVars';
import 'font-awesome/css/font-awesome.min.css';

  ///sectionLock = No_Lock,Partially_Lock,Complete_Lock

  const config = {
	/* in theory, the MathML input processor should be activated if we add
	an "mml" block to the config OR if "input/mml" (NOT "input/mathml" as stated 
	in the docs) is in the load array. However, this is not necessary as MathML is 
	ALWAYS enabled in MathJax */
	loader: { load: ["input/mml", "output/chtml"] },
	mml: {}
  };

  export default function Execute() {
	const childRef = useRef();  
	const openHelpRef = React.useRef();
	const [pageLoading, setPageLoading] = React.useState(true);
	const [testSet, setTestSet] = React.useState([]); 
	const [currentQuestionObj, setCurrentQuestionObj] = React.useState({});
	const [currentQuestion, setCurrentQuestion] = React.useState(0);
	const [totalQuestion, setTotalQuestion] = React.useState(0);
	const [notVisitedTotal, setNotVisitedTotal] = React.useState(0);
	const [notAnsweredTotal, setNotAnsweredTotal] = React.useState(0);
	const [answeredTotal, setAnsweredTotal] = React.useState(0);
	
	const authResult = new URLSearchParams(window.location.search); 
	const testId = authResult.get('testId');

	const deviceType = authResult.get('device_type');
  	if(deviceType && deviceType.length>0){
    	localStorage.setItem("deviceType", deviceType);
  	}
	
	var counterMRMT = 0, counterMCMT=0;

	const alphaArr = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];

	// check if logged in
	if(localStorage.getItem('etlStudentObj')===null){
		window.location.href='login';
	}

	
	function checkedAnswers(num){
		let questionId = testSet[0].questionSet[num].questionId;
		let checkedAns=[];
		if(testSet[0].questionSet[num].questionType=="Fill-In-Blank"){
			if(document.getElementById("ans"+questionId+"a").value && document.getElementById("ans"+questionId+"a").value.length>0){
				checkedAns.push(document.getElementById("ans"+questionId+"a").value);
			}
		}else if(testSet[0].questionSet[num].questionType=="MR-Matching-Type" || testSet[0].questionSet[num].questionType=="Matching-Type"){
			let totalOptions = Object.keys(testSet[0].questionSet[num].columns[0].columnRows).length;
			totalOptions = totalOptions*totalOptions;
			for(let i=1; i<=totalOptions; i++ ){
				if(document.getElementById("ans"+questionId+"a"+i) && document.getElementById("ans"+questionId+"a"+i).checked==true){
					checkedAns.push(document.getElementById("ans"+questionId+"a"+i).value)
				}	
			}

		}else{
			let totalOptions = Object.keys(testSet[0].questionSet[num].responseChoice).length;
			for(let i=0; i<totalOptions; i++ ){
				if(document.getElementById("ans"+questionId+"a"+i) && document.getElementById("ans"+questionId+"a"+i).checked==true){
					checkedAns.push(document.getElementById("ans"+questionId+"a"+i).value)
				}	
			}

		}
		return checkedAns;		
	}
	
	function mrResponse(num){
		let questionId = testSet[0].questionSet[num].questionId;
		let checkedAns=[];
		checkedAns=checkedAnswers(num);
		if(checkedAns.length){
			document.getElementById('ans'+questionId).innerHTML=checkedAns.join(",");
			document.getElementById('btn'+questionId).classList.remove("qbg-not-visited");
			document.getElementById('btn'+questionId).classList.add("qbg-visited");
			if(document.getElementById('btn'+questionId).style.background.indexOf('answered-review.png')>-1){
			}else if(document.getElementById('btn'+questionId).style.background.indexOf('review.png')>-1){
				document.getElementById('btn'+questionId).style.background="url('"+process.env.PUBLIC_URL+"/answered-review.png')";	
			}else{
				document.getElementById('btn'+questionId).style.background="url('"+process.env.PUBLIC_URL+"/answered.png')";
			}	
		}else{
			document.getElementById('ans'+questionId).innerHTML="";
			document.getElementById('btn'+questionId).classList.remove("qbg-not-visited");
			document.getElementById('btn'+questionId).classList.add("qbg-visited");
			if(document.getElementById('btn'+questionId).style.background.indexOf('answered-review.png')>-1){
				document.getElementById('btn'+questionId).style.background="url('"+process.env.PUBLIC_URL+"/review.png')";
			}else if(document.getElementById('btn'+questionId).style.background.indexOf('review.png')>-1){	
			}else{
				document.getElementById('btn'+questionId).style.background="url('"+process.env.PUBLIC_URL+"/not-answered.png')";
			}
		}		
	}

	function uncheckHandle(chkId){
		if(document.getElementById("hidetxt"+chkId).value==1){
			document.getElementById(chkId).checked=false;
			document.getElementById("hidetxt"+chkId).value="";
		}else if(document.getElementById(chkId).checked==true){
			let totalOptions = Object.keys(testSet[0].questionSet[currentQuestion].responseChoice).length;
			let questionId = testSet[0].questionSet[currentQuestion].questionId;
			for(let i=0; i<totalOptions; i++ ){
				document.getElementById("hidetxtans"+questionId+"a"+i).value="";
			}
			document.getElementById("hidetxt"+chkId).value=1;
		} 
		mrResponse(currentQuestion);
	}
	function backHandle(){
		currentQuestion==0?jumpToQuestion(0):jumpToQuestion(currentQuestion-1);
	}
	function nextHandle(){
		if(totalQuestion==(currentQuestion+1)){
			jumpToQuestion(0);
		}else{
			currentQuestion==(totalQuestion-1)?jumpToQuestion(currentQuestion):jumpToQuestion(currentQuestion+1);
		}	
	}	
	function changeCurrentQuestion(num){
		document.getElementById('questionBox'+currentQuestion).style.display="none";
		document.getElementById('questionBox'+num).style.display="";
		setCurrentQuestion(num);
		setCurrentQuestionObj(testSet[0].questionSet[num]);
	}
	function jumpToQuestion(num){
		if(num!=currentQuestion){
			changeCurrentQuestion(num);
		}
	}
	function backToReports(){ 
		if(testId!=null){
			let testType = 	testId.substring(0,2);
			if(testType==="mt"){		
				window.location.href='analytics?testId='+testId.substring(2,testId.length);
			}else if(testType==="ls"){		
				window.location.href='learning-testanalytics?testId='+testId.substring(2,testId.length);	
			}else{
				window.location.href='testanalytics?testId='+testId.substring(2,testId.length);
			}
		}
	}
	

	React.useEffect(() => {
		getApiData();	
	}, []); 

	async function getApiData(){
		
		axios.get(API_URL+'/app/testresultview?testSession='+testId)
			   .then(response => {
				setPageLoading(false);
				///document.write(JSON.stringify(response.data));
				if(response.data!=null && response.data[0]!=null){

					setTestSet(response.data);						

					const apiResponseData = response.data ;

					setNotVisitedTotal(apiResponseData[0].notAnsweredCount);
					setNotAnsweredTotal(apiResponseData[0].incorrectCount);
					setAnsweredTotal(apiResponseData[0].correctCount);

					if(apiResponseData[0] && apiResponseData[0].questionSet){						
						setCurrentQuestionObj(apiResponseData[0].questionSet[0]);
						if(document.getElementById('questionBox'+currentQuestion)){
							document.getElementById('questionBox'+currentQuestion).style.display="";
						}
						setTotalQuestion(Object.keys(apiResponseData[0].questionSet).length);
						childRef.current.resetTimer();
						if(document.getElementById('notVisitedTotalDivId')){
							document.getElementById('notVisitedTotalDivId').innerHTML=Object.keys(apiResponseData[0].questionSet).length;
						}
					}
				}					
			}).catch((error) => {
				console.log("ERROR: ", error);
			})
	}

    function openTopNav(divid) {
		document.getElementById(divid).style.width = "250px";
		document.getElementById('timingBoxId').classList.add("testTimingBoxLeft");
		document.getElementById('timingBoxId').classList.remove("testTimingBox");
		document.getElementById('questionPanelId').classList.remove("questionPanelFull");
		document.getElementById('questionPanelId').classList.add("questionPanelShort");
	}
	  
	function closeTopNav(divid) {
		document.getElementById(divid).style.width = "0";
		document.getElementById('timingBoxId').classList.remove("testTimingBoxLeft");
		document.getElementById('timingBoxId').classList.add("testTimingBox");
		document.getElementById('questionPanelId').classList.add("questionPanelFull");
		document.getElementById('questionPanelId').classList.remove("questionPanelShort");
	}

	function openHelp(){
		openHelpRef.current.handleClickOpen();
	}


	  
	// function convertToArray(str){
	// 	let retArr = [];
	// 	if(str.length>0){
	// 		let strArr = str.split("<math");
	// 		for(let i=0; i<strArr.length; i++){
	// 			if(strArr[i].indexOf("</math>")>-1 && strArr[i].indexOf("xmlns=")>-1){
	// 				let strZArr = strArr[i].split("</math>");
	// 				if(strZArr[0] && strZArr[0].indexOf("xmlns=")>-1){
	// 					retArr.push("<math "+strZArr[0].trim().replace(/[\r\n]+/g, '')+"</math>");
	// 				}
	// 				if(strZArr[1]){
	// 					retArr.push(strZArr[1].trim().replace(/[\r\n]+/g, ''));
	// 				}
	// 			}else{
	// 				retArr.push(strArr[i].trim().replace(/[\r\n]+/g, ''));
	// 			}
	// 		}
	// 	}

	// 	return retArr;
	// }

  /* RIGHT CLICK DISABLED ON THIS COMPONENT */
  document.addEventListener("contextmenu", (event) => {
	event.preventDefault();
  });

  /* CTRL KEY DISABLED ON THIS COMPONENT */
  document.addEventListener("keydown", function (event) {
    if (event.ctrlKey) {
        event.preventDefault();
    }   
  });

  /* REFRESH PAGE DISABLED ON THIS COMPONENT */
  if (window.performance) {
	if (performance.navigation.type == performance.navigation.TYPE_RELOAD) {
		document.addEventListener("keydown", function (event) {
			if ((event.which || event.keyCode) == 116 || (event.which || event.keyCode) == 17 || ((event.which || event.keyCode) == 82 )) {
				// Pressing F5 or Ctrl+R
				event.preventDefault();
			}   
		  });  
	} 
  }

  function onBodyClickAction() {
	if(window.screen.width<480){
	  closeTopNav('mySidepanel');
	}
  }


	return (
			<div> 
				<MetaTags>
            		<title>View Test Result</title>
            		<meta name="description" content="View Test Result" />
          		</MetaTags>
				  {!window.navigator.onLine?
    <div className='netBar' >Alert: It seems, you are not connected to the internet.</div>
    :null}
				<Box style={{marginBottom:100, marginLeft:20, marginRight:20}}>					
				{pageLoading?<LinearProgress />:null}	

	{(testSet[0] && testSet[0]!=null && testSet[0].questionSet)?<>		
				<Box mt={1} className="noselect" >
						<Grid container spacing={2}>
							<Grid item md={12} xs={12}>
							{testSet[0]?<span className='test-name' >{testSet[0].testName}</span>:null}
							</Grid>	
							<Grid id="timingBoxId" item md={6} xs={12} className='testTimingBoxLeft' ></Grid>						
						</Grid>
				</Box>

		{(testSet[0] && testSet[0].questionSet)?	
		<Box id="questionPanelId" className="questionPanelShort" onClick={()=>{onBodyClickAction()}} >	
		{testSet[0].questionSet.map((myQuestion,myqnum) => (
				<Box key={'qes'+myqnum} className="noselect" id={'questionBox'+myqnum} style={{display:'none'}}  >
						<Grid container spacing={2} >
							<Grid item md={12} xs={12} >
								{myQuestion.sectionName?<div className='taglabelblu mr5' >Section: {myQuestion.sectionName}</div>:null}
								<div className='taglabelblu mr5' >Question Type: {myQuestion.questionTypeLabel}</div>
								<div className='taglabelblu mr5' >Question Id: {myQuestion.questionDisplayId}</div>
								
							{(myQuestion.correctAnswerMarks && myQuestion.correctAnswerMarks>0)?<>	
								<span className='taglabelgreen mr5' >Correct: {myQuestion.correctAnswerMarks}</span>
								<span className='taglabelred mr5' >Incorrect: {myQuestion.incorrectAnswerMarks}</span>
								<span className='taglabelyellow' >Not Answer: {myQuestion.notAnswerMarks}</span>	
							</>:null}
								
							</Grid>
							<Grid item md={12} xs={12} className="questionBox" >
								{(myQuestion.commonDataDescription && myQuestion.commonDataDescription.length>0)?<p className="preWrap animate-zoom" >
									{
										 <MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myQuestion.commonDataDescription.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>									
									}
								</p>:null}
								<p className="preWrap animate-zoom" >
								<span className="questionNum" >Question {myqnum+1}: </span> 
								{(myQuestion.questionBody && myQuestion.questionBody.length>0)?<span>
									{
										 <MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myQuestion.questionBody.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>									
									}
								</span>:null}										
								</p>
								{
									myQuestion.columns?
									<p className="animate-zoom">
										<table width="100%">
											<tr>
												{
													myQuestion.columns.map((myRow,index) => (	
														<td className="btmbdrgry pdlft10"><h3>{myRow.columnHeader}</h3></td>
													))		
  												}
											</tr>	
												<tr>
												{myQuestion.columns.map((myCol,indexCol) => (
													<td><table width="100%">{
														myCol.columnRows.map((myRow,indexrrr) => (
															<tr>
															<td key={'crwq'+indexrrr+'dd'+indexCol} className="btmbdrgry pdlft10 content-justify preWrap" >
																{myRow.rowId}.&nbsp;
																{(myRow.rowName && myRow.rowName.length>0)?
																	 <MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myRow.rowName.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>									
																 :null														
																}
																</td>
															</tr>
														))
  														}</table>
													</td>
												))}
												</tr>
										</table>
									</p>
									:null
								}
								<p className="answerBox animate-zoom" >
								{
									myQuestion.questionType=='Matching-Type'?
									<table><span hidden>{counterMRMT=0}</span>
										<tr><th className="mrmtcol" ></th>{myQuestion.columns[1].columnRows.map((myRow,index) => (<th key={'mrmatch'+index} className="mrmtcol" >{myRow.rowId}</th>))}</tr>
										{myQuestion.columns[0].columnRows.map((myRowLeft,indexLeft) => (
											<tr key={'trmmt'+indexLeft} ><th className="mrmtcol" >{myRowLeft.rowId}</th>{myQuestion.columns[1].columnRows.map((myRowRight,indexRight) => (<td key={'mrmtchkb'+indexRight} className={(myQuestion.studentResponse && myQuestion.correctResponse && (myQuestion.correctResponse.indexOf(alphaArr[counterMRMT])>-1 && myQuestion.studentResponse.indexOf(alphaArr[counterMRMT])>-1))?"mrmtcol bggreenans":(myQuestion.studentResponse && myQuestion.correctResponse && (myQuestion.correctResponse.indexOf(alphaArr[counterMRMT])==-1 && myQuestion.studentResponse.indexOf(alphaArr[counterMRMT])>-1))?"mrmtcol bgredans":"mrmtcol"} ><input disabled type="radio" id={"ans"+myQuestion.questionId+"a"+(counterMCMT=counterMCMT+1)} value={alphaArr[counterMRMT-1]} name={"ans"+myQuestion.questionId+'tr'+indexLeft} className="inputRadio" /></td>))}</tr>
										))}
									</table>
									:myQuestion.questionType=='MR-Matching-Type'?
									<table><span hidden>{counterMRMT=0}</span>
										<tr><th className="mrmtcol" ></th>{myQuestion.columns[1].columnRows.map((myRow,index) => (<th key={'mrmatch'+index} className="mrmtcol" >{myRow.rowId}</th>))}</tr>
										{myQuestion.columns[0].columnRows.map((myRowLeft,indexLeft) => (
											<tr key={'trmmt'+indexLeft} ><th className="mrmtcol" >{myRowLeft.rowId}</th>{myQuestion.columns[1].columnRows.map((myRowRight,indexRight) => (<td key={'mrmtchkb'+indexRight} className={(myQuestion.correctResponse && myQuestion.correctResponse.indexOf(alphaArr[counterMRMT])>-1)?"mrmtcol bggreenans":(myQuestion.studentResponse && myQuestion.studentResponse.indexOf(alphaArr[counterMRMT])>-1)?"mrmtcol bgredans":"mrmtcol"} ><input disabled type="checkbox" id={"ans"+myQuestion.questionId+"a"+(counterMRMT=counterMRMT+1)} value={alphaArr[counterMRMT-1]} className="inputRadio" /></td>))}</tr>
										))}
									</table>
									:myQuestion.questionType=='Multiple-Response'?
										myQuestion.responseChoice.map((myRow,index) => (
											<p key={'qkey'+myqnum+index} id={'qmrid'+myqnum+index} >										
												<span className="inputSpan" ><input disabled type="checkbox" id={"ans"+myQuestion.questionId+"a"+index} value={myRow.responseId} className="inputRadio" /></span>	
												<span className="inputLable" style={{marginRight:10,fontWeight:'normal'}}>{alphaArr[index]}.</span>
												<span className="inputLable content-justify preWrap" >
													<label for={"ans"+myQuestion.questionId+"a"+index} >														
														{(myRow.responseText && myRow.responseText.length>0)?
															 <MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myRow.responseText.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>									
														:null														
														}
														{(myQuestion.correctResponse && myQuestion.correctResponse.indexOf(myRow.responseId)>-1)?<span className='correct-answer'><i className="fa fa-check"></i> Correct Answer</span>:null}														
														{(myQuestion.studentResponse && myQuestion.studentResponse.indexOf(myRow.responseId)>-1 && myQuestion.studentResponse!=myQuestion.correctResponse)?<span className='incorrect-answer'>You selected</span>:null}														
													</label>
												</span>
											</p>
										))
									:myQuestion.questionType=='Integer-Type'?	
										<table><tr>{	
									    myQuestion.responseChoice.map((myRow,index) => (
											<td key={'atdit'+index} className={(myRow.responseId==myQuestion.correctResponse)?"correct-answer":(myRow.responseId==myQuestion.studentResponse && myRow.responseId!=myQuestion.correctResponse)?"incorrect-answer":null} >	
												<span className="inputSpan" ><input disabled value={myRow.responseId} type="radio" id={"ans"+myQuestion.questionId+"a"+index} onClick={()=>{uncheckHandle("ans"+myQuestion.questionId+"a"+index)}} name={"ans"+myQuestion.questionId} className="inputRadio" /></span>	
												<span className="inputLableIT"><label for={"ans"+myQuestion.questionId+"a"+index} >{myRow.responseText}</label></span> 
												<input type="hidden" id={"hidetxtans"+myQuestion.questionId+"a"+index} />
											</td>
										))}
										</tr></table>
									:(myQuestion.questionType=='Fill-In-Blank' || myQuestion.questionType=='Fill-in-Blank')?	
										<table><tr>
											<td>
											<input disabled type="text" id={"ans"+myQuestion.questionId+"a"} value={myQuestion.studentResponse} placeholder="Enter your answer" />
											{(myQuestion.studentResponse && myQuestion.studentResponse==myQuestion.correctResponse)?<span className='correct-answer'><i className="fa fa-check"></i> Correct Answer</span>:(myQuestion.studentResponse && myQuestion.studentResponse!=myQuestion.correctResponse)?<><span className='incorrect-answer'><i className="fa fa-times"></i> Incorrect Answer</span><span className='correct-answer'>Answer: {myQuestion.correctResponse}</span></>:<span className='correct-answer'>Answer: {myQuestion.correctResponse}</span>}
											
											</td>
										</tr></table>
									:myQuestion.responseChoice.map((myRow,index) => (	
											<p key={'qkey'+myqnum+index} id={'qmrid'+myqnum+index} >
												
												<span className="inputSpan" ><input disabled value={myRow.responseId} type="radio" id={"ans"+myQuestion.questionId+"a"+index} onClick={()=>{uncheckHandle("ans"+myQuestion.questionId+"a"+index)}} name={"ans"+myQuestion.questionId} className="inputRadio" /></span>	
												<span className="inputLable" style={{marginRight:10,fontWeight:'normal'}}>{alphaArr[index]}.</span>
												<span className="inputLable content-justify preWrap" >
													<label for={"ans"+myQuestion.questionId+"a"+index} >
														{(myRow.responseText && myRow.responseText.length>0)?
															 <MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myRow.responseText.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>									
														:null														
														}
														{(myRow.responseId==myQuestion.correctResponse)?<span className='correct-answer'><i className="fa fa-check"></i> Correct Answer</span>:null}														
														{(myRow.responseId==myQuestion.studentResponse && myQuestion.studentResponse!=myQuestion.correctResponse)?<span className='incorrect-answer'><i className="fa fa-times"></i> You selected incorrect</span>:null}														
													</label>													
												</span> 
												<input type="hidden" id={"hidetxtans"+myQuestion.questionId+"a"+index} />
											</p>										
										))									
								}								
								</p>
								
								{(myQuestion.explanations!=null && myQuestion.explanations.length>0)?<p style={{marginBottom:100,marginTop:-50}}><span className="questionNum" >Explanation: </span>{
										<MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myQuestion.explanations.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>
								}</p>:null}

							</Grid>
						</Grid>
				</Box>
		))}
		</Box>	
		:null}		

				


				<div className="sidepanelOpen">
					<Button className="openbtn" onClick={() => { openTopNav('mySidepanel') }} ><i className="fa fa-chevron-left"></i></Button>		
				</div>				
				<div id="mySidepanel" className="sidepanel"> 
						<Button className="closebtn" onClick={() => { closeTopNav('mySidepanel') }} ><i className="fa fa-chevron-right"></i></Button>		

					<Box className="noselect qnumBoxA" >
						<Grid container spacing={2}>
							<Grid item md={12} xs={12}  >
							{(testSet[0] && testSet[0].sectionSet)?testSet[0].sectionSet.map((myQus,secIndex) => (
								<>
									{myQus.sectionName?<div key={'secnm'+secIndex} className="sectionq clrboth">{myQus.sectionName}</div>:null}
									{myQus.questionNumbers.map((myQN,numIndex) => (
										<>
										<span key={'ansnm'+numIndex} id={'ans'+myQN.questionId} hidden ></span>
										{(myQN.answerStatus && myQN.answerStatus=="Correct")?<Button key={'secbtn'+numIndex} id={'btn'+myQN.questionId} className="qbg-visited" style={{background:"url('"+process.env.PUBLIC_URL+"/answered.png')"}} onClick={() => { jumpToQuestion(parseInt(myQN.questionIndex)) }} title={'Go to question: '+(parseInt(myQN.questionIndex)+1)} >{parseInt(myQN.questionIndex)+1}</Button>
										:(myQN.answerStatus && myQN.answerStatus=="Incorrect")?<Button key={'secbtn'+numIndex} id={'btn'+myQN.questionId} className="qbg-visited" style={{background:"url('"+process.env.PUBLIC_URL+"/not-answered.png')"}} onClick={() => { jumpToQuestion(parseInt(myQN.questionIndex)) }} title={'Go to question: '+(parseInt(myQN.questionIndex)+1)} >{parseInt(myQN.questionIndex)+1}</Button>
										:<Button key={'secbtn'+numIndex} id={'btn'+myQN.questionId} className="qbg-not-visited" style={{background:"url('"+process.env.PUBLIC_URL+"/not-visited.png')"}} onClick={() => { jumpToQuestion(parseInt(myQN.questionIndex)) }} title={'Go to question: '+(parseInt(myQN.questionIndex)+1)} >{parseInt(myQN.questionIndex)+1}</Button>
										}
										</>
									))}
								</>
							)):null}
							</Grid>
						</Grid>
					</Box>	
					<Box className='bottomBoxFixed' >
						<Grid item md={6} xs={12} className="noselect" >
								
								<div className="qbg-mr"><div className="qbg-not-visited" style={{background:"url('"+process.env.PUBLIC_URL+"/not-visited.png')"}} id="notVisitedTotalDivId" >{notVisitedTotal}</div> Not Answered</div>
								<div className="qbg-mr" style={{marginLeft:'-1px'}}><div className="qbg-visited" style={{background:"url('"+process.env.PUBLIC_URL+"/not-answered.png')"}} id="notAnsweredTotalDivId" >{notAnsweredTotal}</div> Incorrect</div>
								<div className="qbg-mr clrboth"><div className="qbg-visited" style={{background:"url('"+process.env.PUBLIC_URL+"/answered.png')"}} id="answeredTotalDivId" >{answeredTotal}</div> Correct</div>
										
						</Grid>
					</Box>				
				</div>				

	</>:null}
	</Box>

	{(testSet[0] && testSet[0]!=null && testSet[0].questionSet)?									
				<Box className='bottomBoxFixedA' >
						<Grid container >
							<Grid item md={12} xs={12} className="textButtonBox" >
								<Button title="Previous" variant="contained" onClick={currentQuestion > 0 ? () => { backHandle() }:()=>{}} color={currentQuestion > 0 ?"primary":"inherit"} >Back</Button>
								{(currentQuestionObj && (!currentQuestionObj.explanations || (currentQuestionObj.explanations && currentQuestionObj.explanations.length<1)))?
									<Button title="Help" variant="contained" onClick={() => {openHelp()}} style={{backgroundColor:'green',color:'white'}} >Help</Button>
  								:null}
								{/* Teacher Support */}
								<DialogFeedback currentQuestionObj={currentQuestionObj} />
								<Button title="Back to Previous Page" variant="contained" onClick={() => {backToReports()}} style={{backgroundColor:'#dd8313',color:'#FFF'}} >Exit</Button>
								<Button title="Save & Next" variant="contained" onClick={() => { nextHandle() }} color="primary" >Next</Button>
							</Grid>
							

						</Grid>
				</Box>
	:null}			

			<TestViewDetailsHelp ref={openHelpRef} currentQuestionObj={currentQuestionObj} />

			</div>


	);
 
}




